import { getOSS } from '../api/oss';
import { Client } from 'minio';
import exporter from 'vue-awesome-swiper/dist/exporter';

/**
 * 检查文件类型
 * @param {FileList} files 文件
 * @param {string} fileType 文件
 */
export function checkedFileType(files, fileType) {
  const fileTypes = fileType.split(',');
  const pass = Array.from(files).every(({ type: fileType, name }) => {
    const nameCheck = fileTypes.some(type =>
      name.toLocaleLowerCase().includes(type)
    );
    const typeCheck = fileTypes.some(
      type =>
        !!fileType && type.toLocaleLowerCase().includes(fileType.split('/')[1])
    );
    return nameCheck || typeCheck;
  });
  if (!pass) throw Error('文件格式错误');
}

/**
 * 文件大小检测
 */
export function checkFileSize(files, fileSize) {
  fileSize = fileSize * 1024 * 1024;
  const pass = Array.from(files).every(({ size }) => size <= fileSize);
  if (!pass) throw Error('文件大小错误');
}

/*
 * * 获取OSS客户端
 * @param {Object} OSS - ali-oss
 */
export function getOSSClient(OSS) {
  return getOSS().then(({ data: { data } }) => {
    const {
      accessKeyId,
      accessKeySecret,
      bucketName: bucket,
      ossEndpoint: endpoint,
      securityToken: stsToken
    } = data;
    return new OSS({
      accessKeyId,
      accessKeySecret,
      bucket,
      endpoint,
      stsToken
    });
  });
}

/**
 * 获取文件名称
 * @param {File} file 文件
 */
export function getFileName(file) {
  const { name } = file;
  return name;
}
/**
 * * 将dataUrl转为File
 * @param {string} dataUrl - 待转换的dataUrl
 * @param {string} fileName - 转换后file对象的名称
 */
export function dataURLtoFile(dataUrl, fileName) {
  var arr = dataUrl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}

/**
 * * 获取图片文件的DataURL
 * @param {File} file - 文件
 * @param {string} fileType - 文件格式
 */
export function getFileDataURL(file, fileType = 'image') {
  return new Promise((resolve, reject) => {
    if (!file.type.includes(fileType)) {
      const msg = '请上传正确格式的文件！';
      return reject(msg);
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.addEventListener('load', ({ target: { result } }) =>
      resolve(result)
    );
    reader.addEventListener('error', reject);
  });
}
/**
 * minio下载
 * @param {string} url
 */
export async function downMinioLoadFile(minioClient, backetName, url) {
  const fileName = url.split(backetName)[1];
  const formateUrl = await minioClient.presignedUrl(
    'GET',
    backetName,
    fileName
  );
  return formateUrl;
}

/**
 * 下载文件
 */
export function downLoadingFile() {}

/**
 * 字符串转二维数组
 * @param {string} param
 */
export function stringToArray(param) {
  let arr = param.split(';');
  arr = arr.filter(item => item);
  arr = arr.map(item => {
    return item.split('\n').map(item =>
      item.split(',').map(item => {
        return item * 1;
      })
    );
  });
  return arr;
}

/**
 * 切割数组
 * @param {Array} params
 */
export function sliceParamAarry(params) {
  let index = 0;
  let newArray = [];
  while (index < params.length) {
    newArray.push(params.slice(index, (index += 5)));
  }
  // const paramsArr = newArray.map(item => {
  //   item.map(({ paramName }) => `relicAutoIncrementId=${paramName}`).join('&');
  // });
  return newArray;
}
